import React from "react"
import { Box } from "@mui/material"
import styles from "./ModalDefault.module.scss"
/**
 * お見積もり対象外の車モーダル
 */
const ModalUnsupportedCar = () => {
  return (
    <>
      <Box className={styles.modalTitle}>
        <h3>お見積り対象外の車</h3>
      </Box>
      <Box className={styles.modalParagraph}>
        <p>
          以下の車は、お見積りいただけません。
          <br />
          <small>・型式の末尾に「改」または「カイ」が付いているお車（改造車）</small>
          <br />
          <small>・型式が「ハイフン（－）」で囲まれているお車（並行輸入車）</small>
          <br />
          <small>・型式が「不明」、「フメイ」、「ＦＵＭＥＩ」となっているお車（型式不明車）</small>
        </p>
      </Box>
    </>
  )
}

export default ModalUnsupportedCar
